import useFaqState from './useFaqState'
import { IFaqCategory } from '../faq.types'
import { useMemo } from 'react'

const useFaqCategory = (id: IFaqCategory['id']) => {
  const { categories } = useFaqState()

  return useMemo(() => {
    return categories.find((c) => c.id === id)
  }, [categories, id])
}

export default useFaqCategory
